import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import api from "@/mechanic/lib/api";
import { AlertTriangle } from "lucide-react";

export default function LowStockBanner() {
  const { data } = useQuery({
    queryKey: ["mech-alerts"],
    queryFn: async () => (await api.get("/alerts")).data,
    refetchInterval: 60000,
  });
  if (!data?.count) return null;
  const items = [
    ...data.low_oils.map((o) => `${o.name} — ${Number(o.stock_litres).toFixed(1)}L left (reorder at ${o.reorder_threshold_litres}L)`),
    ...data.low_parts.map((p) => `${p.name} — ${p.qty_on_hand} left (reorder at ${p.reorder_threshold})`),
  ];
  return (
    <div className="bg-amber-500/15 border-b border-amber-500/40 px-6 py-2.5 flex items-start gap-3" data-testid="low-stock-banner">
      <AlertTriangle className="h-4 w-4 text-amber-400 mt-0.5 shrink-0" />
      <div className="text-sm flex-1">
        <span className="font-semibold text-amber-400">Reorder soon:</span>{" "}
        <span className="text-amber-300">{items.join(" · ")}</span>
      </div>
      <Link to="/mechanic/inventory" className="text-xs font-semibold text-amber-400 underline whitespace-nowrap" data-testid="low-stock-banner-link">
        View inventory
      </Link>
    </div>
  );
}
